import { ValueOf } from 'shared/types/generic'
import { FontSizeOptions } from 'shared/ui/utils/designTokens'



export const PagebuilderMaxContentWidthOptions = {
  full: 'full',
  default: 'default',
  custom: 'custom'
} as const

export type PagebuilderMaxContentWidthOptions = ValueOf<typeof PagebuilderMaxContentWidthOptions>

export const PagebuilderAlignOptions = {
  left: 'left',
  right: 'right',
  center: 'center'
} as const

export type PagebuilderAlignOptions = ValueOf<typeof PagebuilderAlignOptions>

export const PagebuilderHeadingTagOptions = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3'
} as const

export type PagebuilderHeadingTagOptions = ValueOf<typeof PagebuilderHeadingTagOptions>

// Size options are based on the Design System
export const PagebuilderHeadingSizeOptions = {
  ...Object.keys(FontSizeOptions).map((key) => [key, key] as const),
  custom: 'custom'
} as const

export type PagebuilderHeadingSizeOptions = ValueOf<typeof PagebuilderHeadingSizeOptions>

export const PagebuilderButtonPlacementOptions = {
  left: 'left',
  center: 'center',
  right: 'right',
  full: 'full'
} as const

export type PagebuilderButtonPlacementOptions = ValueOf<
  typeof PagebuilderButtonPlacementOptions
>

export const PagebuilderSectionBackgroundType = {
  transparent: 'transparent',
  filled: 'filled',
  image: 'image'
} as const

export type PagebuilderSectionBackgroundType = ValueOf<typeof PagebuilderSectionBackgroundType>

export const PagebuilderSectionBackgroundImageFit = {
  contain: 'contain',
  cover: 'cover',
  fill: 'fill'
} as const

export type PagebuilderSectionBackgroundImageFit = ValueOf<typeof PagebuilderSectionBackgroundImageFit>

export const PagebuilderSectionBackgroundImagePosition = {
  center: 'center center',
  top: 'center top',
  right: 'right center',
  bottom: 'center bottom',
  left: 'left center'
} as const

export type PagebuilderSectionBackgroundImagePosition = ValueOf<
  typeof PagebuilderSectionBackgroundImagePosition
>

export interface SharedFieldProps {
  name?: string
  title?: string
  hidden?: boolean | ((context: { parent?: unknown }) => boolean)
  fieldset?: string
}

export interface PagebuilderImageAspectRatioSchema {
  desktop?: string
  mobile?: string
}

export const PagebuilderSectionNames = {
  pagebuilderBaseContentSection: 'pagebuilderBaseContentSection',
  pagebuilderSplitContentSection: 'pagebuilderSplitContentSection',
  pagebuilderTilesGridSection: 'pagebuilderTilesGridSection',
  pagebuilderBannersGridSection: 'pagebuilderBannersGridSection',
  pagebuilderMarqueeSection: 'pagebuilderMarqueeSection',
  pagebuilderNewsletterFormSection: 'pagebuilderNewsletterFormSection'
} as const

export type PagebuilderSectionNames = ValueOf<typeof PagebuilderSectionNames>

export interface RichTextChild {
    text?: string
}

export interface RichTextBlockLite {
    children?: RichTextChild[]
}
